module.exports = ebui_vendor;